const indexItems = [
  { id: 1, icon: 'ri-rocket-2-line', title: '科幻巨制', count: '286部', color: 'bg-accent-100 text-accent-700' },
  { id: 2, icon: 'ri-sword-line', title: '动作大片', count: '412部', color: 'bg-primary-100 text-primary-700' },
  { id: 3, icon: 'ri-emotion-laugh-line', title: '喜剧精选', count: '358部', color: 'bg-secondary-100 text-secondary-700' },
  { id: 4, icon: 'ri-ghost-line', title: '悬疑推理', count: '203部', color: 'bg-accent-100 text-accent-700' },
  { id: 5, icon: 'ri-heart-pulse-line', title: '爱情文艺', count: '267部', color: 'bg-primary-100 text-primary-700' },
  { id: 6, icon: 'ri-magic-line', title: '动画奇幻', count: '189部', color: 'bg-secondary-100 text-secondary-700' },
  { id: 7, icon: 'ri-earth-line', title: '纪录写实', count: '145部', color: 'bg-accent-100 text-accent-700' },
  { id: 8, icon: 'ri-surround-sound-line', title: '恐怖惊悚', count: '178部', color: 'bg-primary-100 text-primary-700' },
  { id: 9, icon: 'ri-star-line', title: '经典佳作', count: '520部', color: 'bg-secondary-100 text-secondary-700' },
];

export default function IndexSection() {
  return (
    <section id="index" className="w-full py-16 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-3">专题合集</h2>
          <p className="text-sm text-foreground-500">按类型快速发现，精准定位你的观影口味</p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-4">
          {indexItems.map((item) => (
            <a
              key={item.id}
              href="#hero"
              className="bg-background-50 rounded-xl p-4 border border-background-200/70 hover:border-accent-300/60 transition-all duration-300 cursor-pointer group text-center"
            >
              <div className={`w-10 h-10 mx-auto mb-3 rounded-xl flex items-center justify-center ${item.color}`}>
                <i className={`${item.icon} text-lg`}></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1">{item.title}</h3>
              <span className="text-xs text-foreground-400">{item.count}</span>
            </a>
          ))}
        </div>
        <div className="text-center mt-8">
          <a
            href="#hero"
            className="inline-flex items-center gap-1 text-sm text-accent-600 hover:text-accent-700 font-medium transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部类型 <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}